require('./ProgramRating.scss');
require('./_Size/ProgramRating_Size_S.scss');
require('./_Size/ProgramRating_Size_M.scss');

const b = require('app/www/libs/b')('program-rating');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Tooltip = require('app/www/components/blocks/Tooltip/Tooltip');
const Ua = require('app/www/components/blocks/Ua/Ua');

const {GOOD_RATING} = require('app/www/constants/programRating');
const TOOLTIP = require('app/www/constants/tooltip');

class ProgramRating extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            tooltip: false,
        };

        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._openTooltip = this._openTooltip.bind(this);
        this._closeTooltip = this._closeTooltip.bind(this);
    }

    render() {
        const {i18n, mods, rate, tooltipProps} = this.props;

        Object.assign(mods, {
            good: rate >= GOOD_RATING,
        });

        return (
            <i
                className={b(mods)}
                ref={ref => (this._rating = ref)}
                onMouseEnter={this._onMouseEnter}
                onMouseLeave={this._onMouseLeave}
            >
                {rate}
                {this.state.tooltip && (
                    <Tooltip
                        ref={ref => (this._tooltip = ref)}
                        owner={this._rating}
                        {...tooltipProps}
                    >
                        {i18n.get('program-statistics.rating')}
                    </Tooltip>
                )}
            </i>
        );
    }

    /**
     * @private
     */
    _onMouseEnter() {
        if (Ua.isTouch) {
            return;
        }

        this._timeout = setTimeout(this._openTooltip, TOOLTIP.DELAY);
    }

    /**
     * @private
     */
    _onMouseLeave() {
        if (Ua.isTouch) {
            return;
        }

        clearTimeout(this._timeout);
        this._closeTooltip();
    }

    /**
     * @private
     */
    _openTooltip() {
        if (this._tooltip) {
            this._tooltip.open();
        } else {
            this.setState({
                tooltip: true,
            });
        }
    }

    /**
     * @private
     */
    _closeTooltip() {
        if (this._tooltip) {
            this._tooltip.close();
        }
    }
}

ProgramRating.defaultProps = {
    tooltipProps: {
        mods: {
            theme: 'normal',
            size: 's',
        },
        to: 'top',
        isAdaptive: true,
    },
};

ProgramRating.propTypes = {
    mods: PropTypes.object,
    rate: PropTypes.string,
    tooltipProps: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]),
};

module.exports = withI18n(ProgramRating);
